import CalendarEntry from 'owa-service/lib/contract/CalendarEntry';
import CalendarFolderTypeEnum from 'owa-service/lib/contract/CalendarFolderTypeEnum';
import owaCalendarStrings from 'owa-strings/owa-calendar-strings';

export default function getCalendarDisplayName(calendarEntry: CalendarEntry): string {
    return calendarEntry.CalendarFolderType == CalendarFolderTypeEnum.DefaultCalendar
        ? owaCalendarStrings.calendarText
        : calendarEntry.CalendarName;
}
